import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupOverviewComponent } from './group-overview.component';
import { GroupMembersModule } from '../group-members/group-members.module';
import { LoadingComponentModule } from '../loading/loading.module';
import { SimpleSelectModule } from '../simple-select/simple-select.module';



@NgModule({
    declarations: [
        GroupOverviewComponent
    ],
    imports: [
        CommonModule,
        GroupMembersModule,
        LoadingComponentModule,
        SimpleSelectModule,
        LoadingComponentModule,
    ],
    exports: [
        GroupOverviewComponent,
    ]
})
export class GroupOverviewModule { }
